import React from 'react';
import { useQuery } from '@tanstack/react-query';
import platformApiService from '../../services/platformApi';

const fmtDate = (value: string) => new Date(value).toLocaleString();

const PlatformAuditLog: React.FC = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['platform-audit-log'],
    queryFn: async () => {
      const response = await platformApiService.auditLog();
      if (!response.success) throw new Error(response.error?.message || 'Failed to load audit log');
      return response.data || [];
    },
  });

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-xl font-semibold text-white">Platform Audit Log</h1>
        <p className="text-sm text-slate-500">Every status change and impersonation performed by platform operators.</p>
      </div>

      <div className="overflow-hidden rounded-xl border border-slate-800 bg-slate-900">
        {isLoading ? (
          <div className="p-8 text-center text-sm text-slate-500">Loading…</div>
        ) : error ? (
          <div className="p-8 text-center text-sm text-red-300">{(error as Error).message}</div>
        ) : !data || data.length === 0 ? (
          <div className="p-8 text-center text-sm text-slate-500">No platform actions logged yet.</div>
        ) : (
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-slate-800 text-xs uppercase tracking-wider text-slate-500">
                <th className="px-4 py-3 font-medium">When</th>
                <th className="px-4 py-3 font-medium">Operator</th>
                <th className="px-4 py-3 font-medium">Action</th>
                <th className="px-4 py-3 font-medium">Municipality</th>
                <th className="px-4 py-3 font-medium">Details</th>
              </tr>
            </thead>
            <tbody>
              {data.map((entry) => (
                <tr key={entry.id} className="border-b border-slate-800/60 last:border-0">
                  <td className="px-4 py-3 text-slate-400">{fmtDate(entry.created_at)}</td>
                  <td className="px-4 py-3 text-slate-200">{entry.operator_name || '—'}</td>
                  <td className="px-4 py-3 text-slate-300">{entry.action}</td>
                  <td className="px-4 py-3 text-slate-300">{entry.municipality_name || '—'}</td>
                  <td className="px-4 py-3 text-xs text-slate-500">
                    {entry.details && Object.keys(entry.details).length > 0 ? JSON.stringify(entry.details) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default PlatformAuditLog;
